import { render } from "./TilmeldHoldKvittering.vue?vue&type=template&id=372b4048"
import script from "./TilmeldHoldKvittering.vue?vue&type=script&lang=js"
export * from "./TilmeldHoldKvittering.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__